import { LocalTime } from "@js-joda/core";
import React from "react";
import { HashSet } from "../utils/HashSet";
import { CALENDAR_ICON } from "../utils/svgs_new";
import { CheckedVisitData } from "./AvailableVisitActivity";
import { AppIcon } from "./Generic/AppIcon";
import Checkbox from "./Generic/Checkbox";
import { CheckedOnboardingVisitData } from "./OnboardingVisitActivity";

interface Props {
  dayOfWeek: {
    key: string;
    displayDay: string;
    shifts: {
      startAt: LocalTime;
      endAt: LocalTime;
    }[];
    visitInstancesCount: number;
  };
  isMultiShift: boolean;
  checkedPatterns: HashSet<string>;
  requestedVisitBatch: boolean;
  onCheckVisit:
    | ((visitData: CheckedVisitData) => void)
    | ((visitData: CheckedOnboardingVisitData) => void);
}

export default function AvailableWeeklyTemplateShiftItem(props: Props) {
  const handleClick = () => {
    props.onCheckVisit({
      type: "Pattern",
      dayOfWeek: props.dayOfWeek.key,
    });
  };

  return props.isMultiShift ? (
    <Checkbox
      style={{ marginInlineEnd: 15 }}
      onClick={handleClick}
      checked={props.checkedPatterns.has(props.dayOfWeek.key)}
      disabled={props.requestedVisitBatch || props.dayOfWeek.visitInstancesCount === 0}
    />
  ) : (
    <AppIcon icon={CALENDAR_ICON} fill="primary" />
  );
}
